import { render, staticRenderFns } from "./adsorption-measurement-detail.vue?vue&type=template&id=8b861c78&"
import script from "./adsorption-measurement-detail.vue?vue&type=script&lang=js&"
export * from "./adsorption-measurement-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports